import { render, staticRenderFns } from "./ContentBody.vue?vue&type=template&id=06ac5e27&scoped=true"
import script from "./ContentBody.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentBody.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ContentBody.vue?vue&type=style&index=0&id=06ac5e27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ac5e27",
  null
  
)

export default component.exports